import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarViewComponent } from './calendar-view/calendar-view.component';
import { AuthGuard } from '../../../core/auth';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    path: '',
    component: CalendarViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalendarRoutingModule {}
